import React from "react";
import { Card, Descriptions, Tag, Space, Dropdown, message } from "antd";
import { AimOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../context";
import config from "../../../api_config.json";

const MarketplaceOrgRiepilogo = ({ org }) => {
  const { isProd, assumeUnifiedOrg } = useAppContext();

  if (!org) return null;

  const marketplaceOrgId = org.objectId;

  const enterAsFuneralCloud = async () => {
    try {
      message.loading("Ogni suo desiderio è un ordine", 2);
      const result = await assumeUnifiedOrg({ marketplaceOrgId });
      message.success("Super User attivato su FuneralCloud", 2);
      const fcUrl = `${config.funeralcloudUrl[isProd ? "prod" : "dev"]}/logout`;
      window.open(fcUrl, "_blank");
      return result;
    } catch (error) {
      message.error("Si è verificato un problema: " + error.message);
      return null;
    }
  };

  const enterAsEterno = async () => {
    try {
      message.loading("Ogni suo desiderio è un ordine", 2);
      const result = await assumeUnifiedOrg({ marketplaceOrgId });
      if (result?.eterno?.status === "orphan") {
        message.warning("Questa organizzazione FC non ha un account Eterno collegato", 4);
        return;
      }
      message.success("Super User attivato su Eterno", 2);
      const eternoUrl = `${config.ofcUrl[isProd ? "prod" : "dev"]}/logout.php`;
      window.open(eternoUrl, "_blank");
    } catch (error) {
      message.error("Si è verificato un problema: " + error.message);
    }
  };

  const onMenuClick = (e) => {
    if (e.key === "funeralcloud") {
      enterAsFuneralCloud();
    } else if (e.key === "eterno") {
      enterAsEterno();
    }
  };

  const items = [
    { key: "funeralcloud", label: "FuneralCloud" },
    { key: "eterno", label: "Eterno" },
  ];

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Card title="Azioni">
        <Dropdown.Button
          menu={{ items, onClick: onMenuClick }}
          onClick={enterAsFuneralCloud}
          icon={<AimOutlined />}
        >
          Entra come Super User
        </Dropdown.Button>
      </Card>
      <Card title="Informazioni Generali">
        <Descriptions bordered column={2}>
          <Descriptions.Item label="ID">{org.objectId}</Descriptions.Item>
          <Descriptions.Item label="Nome">{org.name}</Descriptions.Item>
          <Descriptions.Item label="P.IVA">{org.vat_code}</Descriptions.Item>
          <Descriptions.Item label="Stato">
            <Tag color={org.is_active ? "green" : "red"}>
              {org.is_active ? "ATTIVO" : "DISATTIVO"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Città">{org.city || "-"}</Descriptions.Item>
          <Descriptions.Item label="Provincia">{org.province || "-"}</Descriptions.Item>
          <Descriptions.Item label="Paese">
            {org.country || "-"} {org.country_code ? `(${org.country_code})` : ""}
          </Descriptions.Item>
          <Descriptions.Item label="Indirizzo">{org.street || "-"}</Descriptions.Item>
          <Descriptions.Item label="Profilo Venditore" span={2}>
            {org.marketplace_seller_pointer ? (
              <Link to={`/funeralcloud/sellers/${org.marketplace_seller_pointer.objectId}`}>
                {org.marketplace_seller_pointer.name}
              </Link>
            ) : (
              "-"
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Organizzazione Eterno" span={2}>
            {org.org_pointer ? (
              <Link to={`/orgs/${org.org_pointer.objectId}`}>
                {org.org_pointer.nome} ({org.org_pointer.objectId})
              </Link>
            ) : (
              "-"
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Data Creazione">
            {new Date(org.createdAt).toLocaleString("it-IT")}
          </Descriptions.Item>
          <Descriptions.Item label="Ultimo Aggiornamento">
            {new Date(org.updatedAt).toLocaleString("it-IT")}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
};

export default MarketplaceOrgRiepilogo;
